<template>
  <TableLayout :permissions="['meihui:insightTemplate:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="场景"><el-select v-model="searchForm.scene" placeholder="场景" clearable>
        <el-option label="日记模板" value="diary_write" />
        <el-option label="觉察模板" value="insight_detail" />
      </el-select></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建模板')" icon="el-icon-plus" v-permissions="['meihui:insightTemplate:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:insightTemplate:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="scene" label="场景" width="100" show-overflow-tooltip>
          <template slot-scope="{row}">{{ row.scene === 'diary_write' ? '日记模板' : '觉察模板' }}</template>
        </el-table-column>
        <el-table-column prop="templateConfigId" label="模板配置ID" width="120" show-overflow-tooltip />
        <el-table-column prop="heroTitle" label="主标题" width="120" show-overflow-tooltip />
        <el-table-column prop="heroSubtitle" label="副标题" width="180" show-overflow-tooltip />
        <el-table-column prop="saveButtonText" label="保存按钮" width="120" show-overflow-tooltip />
        <el-table-column prop="generateButtonText" label="生成按钮" width="120" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑模板', row)" icon="el-icon-edit" v-permissions="['meihui:insightTemplate:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:insightTemplate:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operainsightTemplateWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operainsightTemplateWindow from './operainsightTemplateWindow'
export default {
  name: 'InsightTemplate', extends: BaseTable, components: { TableLayout, Pagination, operainsightTemplateWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '日记/觉察模板', api: '/rentHouse/insightTemplate', 'field.id': 'id', 'field.main': 'heroTitle' })
    this.search()
  }
}
</script>